<template>
  <div class="role-auth">
    <ul class="role-auth-title">
      <li :class="{ active: roleType == '1630981681702' }" @click="chooseType('1630981681702')">
        设计区
      </li>
      <li :class="{ active: roleType == '1630981803194' }" @click="chooseType('1630981803194')">
        提资区
      </li>
      <li :class="{ active: roleType == '1630981811371' }" @click="chooseType('1630981811371')">
        成品区
      </li>
    </ul>
    <div class="role-auth-aside">
      <div class="role-auth_bar">
        <span v-if="roleType=='1630981811371'" style="display: block;margin-bottom: 3px;">请选择目录
          <el-tooltip effect="light" content="目录数据来自系统-目录模版下的成品区一级目录">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
        <select-tree v-if="roleType=='1630981811371'" ref="selectTree" style="width:100%;margin-bottom:12px" :props="catalogueTypeTreeProps" :options="finishedProductArea"
          :value="catalogueType" :clearable="false" :accordion="true" size="small" @getValue="getValue($event)">
        </select-tree>
        <el-input v-model="filterText" placeholder="输入关键字进行过滤" size="small" clearable>
          <template #prefix>
            <i class="el-icon-search el-input__icon" />
          </template>
        </el-input>
      </div>
      <!-- 目录树 -->
      <roleTree :key="roleType" class="role-auth-tree" :role-type="roleType" :filter-text="filterText"
        :style="{'top':roleType=='1630981811371'?'125px':'65px'}" @systemTableClick="systemTableClick"></roleTree>
    </div>
    <div class="role-auth-content">
      <div class="role-bottom-title">
        <span>角色权限</span>
        <div class="buttons">
          <div v-if="checkboxShow">
            <el-checkbox v-model="checked">{{ checkTitle }}</el-checkbox>
          </div>
          <div v-if="!systemAddOption.$isOperation" class="ml10">
            <el-button size="small" @click="togetherCurrentOpen(0)">
              同步当前角色权限
            </el-button>
          </div>
          <div v-if="!systemAddOption.$isOperation&&isShow" class="ml10">
            <el-button v-if="roleType=='1630981811371'" v-preventReClick size="small" class="role-right-button" @click="emptyFinishedArea">
              清空成品区子级目录权限
            </el-button>
            <el-button type="primary" size="small" class="role-right-button" :disabled="isDisabled" @click="submit">
              保存
            </el-button>
          </div>
          <!-- <div v-if="!systemAddOption.$isOperation&&!isShow" class="ml10">
            <el-button type="primary" size="small" @click="togetherCurrent(1)">
              同步所有角色权限
            </el-button>
          </div> -->
        </div>
      </div>
      <div class="role-right-bottom">
        <template>
          <div style="display: flex;justify-content: space-between;">
            <div v-if="!systemAddOption.$isOperation && systemAddOption.roleId == 'Sp_001'&&tableData.length>0" class="role-rigth-title">
              请设置本专业角色对{{ systemAddOption.roleName }}专业文件夹的权限
            </div>
            <div v-else-if="!systemAddOption.$isOperation&& systemAddOption.roleId == 'Sp_002'&&tableData.length>0" class="role-rigth-title">
              请设置其它专业对{{ systemAddOption.roleName }}专业文件夹权限
            </div>
            <div v-else-if="!systemAddOption.$isOperation && systemAddOption.roleId == 'Sp_003'&&tableData.length>0" class="role-rigth-title">
              请设置项目管理下的角色对{{ systemAddOption.roleName }}专业文件夹权限
            </div>

            <div v-else-if="!systemAddOption.$isOperation&& roleType !== '1630981811371'&&tableData.length>0" class="role-rigth-title">
              请设置（{{ systemAddOption.roleName }}）角色对其他专业文件夹权限
            </div>
            <div v-if="!systemAddOption.$isOperation && roleType == '1630981811371'&&tableData.length>0" class="role-rigth-title">
              请设置（{{ systemAddOption.roleName }}）{{ title }}角色对{{ catalogueTypeName }}文件夹的权限
            </div>

            <div v-if="!systemAddOption.$isOperation&&!isShow" class="role-rigth-title">
              新角色暂未同步权限信息
            </div>
          </div>
        </template>
        <template>
          <div v-if="systemAddOption.$isOperation && roleType == '1630981681702'" class="empty mt-40">
            请选择左侧角色或者专业内、专业间、项目管理
          </div>
          <div v-else-if="systemAddOption.$isOperation && roleType == '1630981803194'" class="empty mt-40">
            请选择左侧角色或者专业内、专业间
          </div>
          <div v-else-if="systemAddOption.$isOperation && roleType == '1630981811371'" class="empty mt-40">
            请选择左侧角色或者专业
          </div>
          <div v-if="!systemAddOption.$isOperation&&isShow" v-loading="loading" class="role-project-table" element-loading-text="拼命加载中">
            <rolePermisson :table-data="tableData" :role-type="roleType" :checked="checked"></rolePermisson>
          </div>
        </template>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="togetherCurrentDialog" :before-close="togetherCurrentClose" :close-on-click-modal="false"
      :close-on-press-escape="false" title="同步" width="500px">
      <el-form ref="togetherCurrentForm" size="small">
        <el-form-item label="同步结果">
          <el-radio-group v-model="syncType">
            <el-radio :label="1">合并</el-radio>
            <el-radio :label="0">覆盖</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="togetherCurrentClose">取 消</el-button>
        <el-button v-preventReClick type="primary" size="small" @click="togetherCurrent(0)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import permission from "@/CommonDP/service/docPrivi-service";
import rolePermisson from "@/CommonDP/components/rolePermisson";
import roleTree from "@/CommonDP/components/structure/roleTree";
import { mapState } from "vuex";
import SelectTree from "@/CommonDP/components/selectTree";

const systemAddOptionParams = () => ({
  roleId: "",
  $isOperation: "",
  roleName: "",
  pid: "",
  specId: ""
});
export default {
  name: "RolePermission",
  components: { rolePermisson, roleTree, SelectTree },
  data() {
    return {
      filterText: "",
      systemAddOption: systemAddOptionParams(),
      roleType: "1630981681702",
      tableData: [],
      initRoleList: [],
      loading: false,
      isShow: false,
      finishedProductArea: [],
      catalogueType: '',
      catalogueTypeName: '',
      catalogueTypeTreeProps: {
        value: "id",
        label: "cnName",
        children: "childList" // 子级
      },
      checked: false,
      togetherCurrentDialog: false,
      syncType: 1,
      title: ''
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjInfo: (state) => state.projectMg.prjObj
    }),
    prjId() {
      return this.prjInfo.prjId;
    },
    // 判断是否与原数据发生变化
    isDisabled() {
      return JSON.stringify(this.initRoleList) === JSON.stringify(this.tableData);
    },
    checkboxShow() {
      return this.tableData.length > 1;
    },
    checkTitle() {
      return this.checked ? '取消批量' : '批量选择';
    }
  },
  created() {

  },
  methods: {
    async chooseType(key) {
      this.roleList = [];
      this.roleType = key;
      this.catalogueType = '';
      this.catalogueTypeName = '';
      this.isShow = false;
      this.systemAddOption = systemAddOptionParams();
      if (key === '1630981811371') {
        this.getFinishedProductArea(1);
      }
    },
    systemTableClick(row, node) {
      this.title = row.childList === null ? '专业下' : '';
      this.isShow = false;
      this.checked = false;
      const specId = this.roleType !== '1630981811371' ? node?.parent.data.specId : row.specId;
      this.tableData = [];
      this.systemAddOption.$isOperation = row.$isOperation;
      const roleId = this.roleType !== '1630981811371' ? row.roleId : (!node?.parent.data.$isOperation ? "" : row.roleId);
      const roleName = this.roleType !== '1630981811371' && (row.roleId === 'Sp_001' || row.roleId === 'Sp_002' || row.roleId === 'Sp_003') ? node.parent.data.roleName : row.roleName;
      this.systemAddOption.roleName = roleName;
      this.systemAddOption.roleId = roleId;
      this.systemAddOption.specId = specId;
      this.getDocumentList(roleId, row.$isOperation, specId);
    },
    // 获取对应的权限
    async getDocumentList(roleId, isOperation, specId) {
      const { prjId, roleType, catalogueType } = this;
      // userType 专业间和角色 2 专业内和项目管理 3 成品区3
      if (!isOperation || isOperation === "0") {
        this.loading = true;
        const userType = this.roleType === '1630981811371' ? 3 : ((roleId === 'Sp_001' || roleId === 'Sp_003') ? 3 : 2);
        const params = {
          prjId: prjId,
          roleId,
          oldId: roleType,
          userType,
          specId,
          folderId: catalogueType
        };
        this.loading = false;
        if (this.roleType !== '1630981811371') delete params.folderId;
        await this.getListData(params);
      }
    },
    async getListData(params) {
      const res = this.roleType !== '1630981811371' ? await permission.queryPrjRolePermissionList(params)
        : await permission.queryProductAreaPrjRolePermissionList(params);
      this.tableData = res.data.map((item) => {
        if (item.isRead === 2) {
          item.$show = 1;
          item.$down = 1;
        } else if (item.isRead === 1) {
          item.$show = 1;
          item.$down = 0;
        } else {
          item.$show = 0;
          item.$down = 0;
        }
        if (
          item.isRead === 2 &&
          item.fileNew === 1 &&
          item.folderNew === 1 &&
          item.fileDel === 1 &&
          item.isSubmit === 1 &&
          item.isPlaceFile === 1 &&
          item.isPrint === 1 &&
          item.isPriviSet === 1 &&
          item.priviAll === 1 &&
          item.isSnapshot === 1 &&
          this.roleType == "1630981681702"
        ) {
          item.$selectAll = 1;
        } else if (
          item.$show === 1 &&
          item.$down === 1 &&
          item.folderNew === 1 &&
          item.fileDel === 1 &&
          item.isPriviSet === 1 &&
          item.priviAll === 1 &&
          item.isSnapshot === 1 &&
          this.roleType == "1630981803194"
        ) {
          item.$selectAll = 1;
        } else if (
          item.$show === 1 &&
          item.$down === 1 &&
          item.fileNew === 1 &&
          item.folderNew === 1 &&
          item.fileDel === 1 &&
          item.isPrint === 1 &&
          item.isPriviSet === 1 &&
          item.priviAll === 1 &&
          item.isSnapshot === 1 &&
          this.roleType == "1630981811371"
        ) {
          item.$selectAll = 1;
        } else {
          item.$selectAll = 0;
        }
        return item;
      });
      this.initRoleList = JSON.parse(JSON.stringify(this.tableData));
      if (this.tableData.length > 0) this.isShow = true;
      else this.isShow = false;
    },

    async submit() {
      const { tableData, prjId, roleType, catalogueType } = this;
      const { roleId, $isOperation, specId } = this.systemAddOption;
      const array = tableData.map((item) => {
        if (item.$show === 1 && item.$down === 1) item.isRead = 2;
        else if (item.$show === 1 && item.$down === 0) item.isRead = 1;
        else item.isRead = 0;
        item.parentId = item.folderId;
        item.type = 0;
        item.folderDel = item.fileDel;
        return item;
      });
      const params = {
        list: array,
        prjId,
        oldId: roleType,
        folderId: catalogueType
      };
      const res = this.roleType === '1630981811371' ? await permission.batchProductAreaFolderAuth(params) : await permission.updatePermissionUpdate({ list: array });
      if (res.result === "0") this.$message.success("提交成功");
      await this.getDocumentList(roleId, $isOperation, specId);
      if (this.roleType === '1630981811371') {
        this.getFinishedProductArea(2);
      }
    },
    async togetherCurrent(val) {
      const {
        enterpriseId,
        prjId,
        systemAddOption: { roleId, specId, $isOperation },
        syncType,
        roleType,
        catalogueType
      } = this;
      const userType = this.roleType === '1630981811371' ? 3 : ((roleId === 'Sp_001' || roleId === 'Sp_003') ? 3 : 2);
      if (val === 0) {
        const params = {
          prjId,
          enterpriseId,
          specId,
          roleId,
          syncType,
          oldId: roleType,
          userType,
          folderId: catalogueType
        };
        await permission.syncRolePermission(params);
        this.$message.success("同步成功");
        this.togetherCurrentDialog = false;
        this.getDocumentList(roleId, $isOperation, specId);
      } else {
        const params = {
          enterpriseId,
          isAll: val,
          prjId,
          roleId,
          specId
        };
        const res = await permission.permissionRenew(params);
        if (res.result === "0") {
          this.$message.success("同步成功");
          this.getDocumentList(roleId, $isOperation, specId);
        }
      }
      if (this.roleType === '1630981811371') {
        this.getFinishedProductArea(2);
      }
    },
    async getFinishedProductArea(type) {
      const { prjId, roleType } = this;
      const { data } = await permission.getProductAreaNodeFolderList(prjId, roleType);
      data.forEach(ele => {
        ele.id = ele.folderId;
        ele.cnName = ele.authQuantity > 0 ? ele.folderName + '(' + ele.authQuantity + ')' : ele.folderName;
      });
      this.finishedProductArea = await this.getTree(data, "0");
      if (type === 1) {
        this.catalogueType = this.finishedProductArea[0].folderId;
        this.catalogueTypeName = this.finishedProductArea[0].folderName;
      } else {
        this.$refs.selectTree.initHandle();
      }
    },
    getTree(data, parentId) {
      const tree = [];
      let temp;
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId === parentId) {
          const obj = data[i];
          temp = this.getTree(data, data[i].folderId);
          if (temp.length > 0) {
            obj.childList = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },
    async getValue(value) {
      this.catalogueType = value.valueId;
      this.catalogueTypeName = value.valueTitle.split('(')[0];
      const { prjId, roleType, catalogueType } = this;
      const params = {
        prjId: prjId,
        roleId: this.systemAddOption.roleId,
        oldId: roleType,
        userType: 3,
        specId: this.systemAddOption.specId,
        folderId: catalogueType
      };
      await this.getListData(params);
    },
    togetherCurrentOpen() {
      this.syncType = 1;
      this.togetherCurrentDialog = true;
    },
    togetherCurrentClose() {
      this.togetherCurrentDialog = false;
    },
    async emptyFinishedArea() {
      const { prjId } = this;
      const { roleId, $isOperation, specId } = this.systemAddOption;
      await permission.emptyFinishedArea(prjId);
      this.$message.success("清空成功");
      await this.getDocumentList(roleId, $isOperation, specId);
      this.getFinishedProductArea();
    }
  }
};
</script>
<style lang="scss">
.role-auth-aside {
  .el-tree-node__content {
    line-height: 20px;
    padding: 4px;
  }
}
.role-project-table {
  .el-checkbox {
    width: 100px;
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: var(--key-color) !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.role-auth {
  height: 100%;
  width: 100%;
  padding: 0;
  position: relative;
  .role-auth-title {
    margin: 0;
    z-index: 10;
    display: flex;
    width: 100%;
    padding: var(--small-space) var(--big-space);
    box-sizing: border-box;
    border-bottom: 1px solid #ebefff;
    li {
      line-height: 33px;
      margin-right: 30px;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      font-weight: 600;
      color: var(--info-color)9;
    }
  }
  .role-auth-aside {
    width: 269px;
    height: calc(100% - 55px);
    box-sizing: border-box;
    border-right: 1px solid #ebefff;
    display: flex;
    flex-direction: column;
    .role-auth_bar {
      padding: var(--middle-space) var(--big-space);
      border-bottom: 1px solid #ebefff;
    }
    .role-auth-tree {
      overflow: hidden;
      width: 100%;
      height: 1px;
      flex-grow: 1;
      padding: var(--small-space) 0;
    }
    .role-auth-tree:hover{
      overflow: auto;
    }
  }
  .role-auth-content {
    position: absolute;
    left: 269px;
    right: 0;
    bottom: 0;
    top: 55px;
    .role-bottom-title {
      display: flex;
      justify-content: space-between;
      padding: var(--middle-space) var(--big-space);
      line-height: 32px;
      span {
        font-size: 16px;
        font-weight: 700;
      }
      .buttons {
        display: flex;
        .ml10{
          margin-left:10px
        }
      }
    }
    .role-right-bottom {
      padding: 0 var(--big-space);
      .role-rigth-title {
        color: #58667a;
        font-size: 14px;
        line-height: 18px;
      }
      .role-project-table {
        overflow: auto;
        position: absolute;
        top: 85px;
        bottom: 10px;
        right: 0;
        padding-right: 20px;
        left: 17px;
      }
      .role-left-button {
        float: left;
        margin-top: 10px;
      }
      .role-right-button {
        float: right;
        margin-top: 10px;
      }
    }
  }
  .active {
    box-sizing: border-box;
    color: var(--theme-color) !important;
    border-bottom: 2px solid var(--theme-color);
  }
  .empty {
    text-align: center;
    font-size: 36px;
    color: #ddd;
    font-weight: bolder;
    letter-spacing: 5px;
  }
  .textAll {
    font-size: 14px;
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
